import axios from "../axios";

// Get all safety areas
export const getHseSafetyAreas = async (params = {}) => {
  const response = await axios.get("/hse_safety_areas", { params });
  return response;
};

// Get a single safety area
export const getHseSafetyArea = async (id) => {
  const response = await axios.get(`/hse_safety_areas/${id}`);
  return response;
};

// Create a new safety area
export const createHseSafetyArea = async (data) => {
  const response = await axios.post("/hse_safety_areas", {
    hse_safety_area: data,
  });
  return response;
};

// Update a safety area
export const updateHseSafetyArea = async (id, data) => {
  const response = await axios.put(`/hse_safety_areas/${id}`, {
    hse_safety_area: data,
  });
  return response;
};

// Delete a safety area
export const deleteHseSafetyArea = async (id) => {
  const response = await axios.delete(`/hse_safety_areas/${id}`);
  return response;
};

// Get templates
export const getHseSafetyAreaTemplates = async () => {
  const response = await axios.get("/hse_safety_areas/templates");
  return response;
};

// Create from template
export const createHseSafetyAreaFromTemplate = async (templateId) => {
  const response = await axios.post("/hse_safety_areas/create_from_template", {
    template_id: templateId,
  });
  return response;
};
